import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgClock(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.25 15.2923V6.74992H14.75V16C14.75 16.4391 14.9804 16.846 15.3569 17.0719L21.4288 20.7149L22.715 18.5712L17.25 15.2923Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 1.75C8.12997 1.75 1.75 8.12997 1.75 16C1.75 23.87 8.12997 30.25 16 30.25C23.87 30.25 30.25 23.87 30.25 16C30.25 8.12997 23.87 1.75 16 1.75ZM4.25 16C4.25 9.51068 9.51068 4.25 16 4.25C22.4893 4.25 27.75 9.51068 27.75 16C27.75 22.4893 22.4893 27.75 16 27.75C9.51068 27.75 4.25 22.4893 4.25 16Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
